import { render, staticRenderFns } from "./Elementary.vue?vue&type=template&id=160128ba"
import script from "./Elementary.vue?vue&type=script&lang=js"
export * from "./Elementary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports